module.exports = __webpack_public_path__ + "static/media/-_Company profile.c70bfa53.png";